import { Markable } from '@medcom/shared-ui/components/Markable.tsx';
import { Flex } from 'antd';
import type React from 'react';
import { AutoTitle } from '../../../../components/AutoTitle.tsx';
import type { CumulativeParameterResults } from '../../../../generated/openapi/befunde-api';
import { useLabResultViewStore } from '../../../../store/useLabResultViewStore.ts';
import { useCumulativeResultsCellStyles } from './useCumulativeResultsCellStyles.ts';

export const CumulativeParameterResultsCell: React.FC<{ parameter: CumulativeParameterResults }> = ({ parameter }) => {
  const styles = useCumulativeResultsCellStyles(false);
  const tokens = useLabResultViewStore(state => state.tokens);
  const unit = parameter.results.reduce((prev, current) => {
    if (current?.unit && !prev.includes(current.unit)) {
      prev.push(current.unit);
    }
    return prev;
  }, [] as string[]);
  return (
    <Flex vertical>
      <div className={styles.value}>
        <Markable tokens={tokens}>
          <AutoTitle content={parameter.name} />
        </Markable>
      </div>
      <div className={styles.sub}>{unit}</div>
    </Flex>
  );
};
